class StoreGloballyExcludedClicker {
  constructor (
    id = undefined,
    name
  ) {
    this.id = id
    this.name = name
  }

  toNormalizedRESTModel () {
    return ({
      id: this.id,
      name: this.name
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name
  }) {
    return new StoreGloballyExcludedClicker(
      id,
      name
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name
    }
  }

  static FromJSON ({
    id,
    name
  }) {
    return new StoreGloballyExcludedClicker(
      id,
      name
    )
  }
}

export default StoreGloballyExcludedClicker
